import { TENANT_PRESETS, resolveTenantId } from './tenantConfig';
import { getActiveTenantId } from '../store/tenantStore';

class Env {
  static get TENANT_ID() {
    return getActiveTenantId();
  }

  /** @deprecated Use TENANT_ID — kept for backward compatibility */
  static get TANENT_ID() {
    return Env.TENANT_ID;
  }

  private static get preset() {
    const tenant = Env.TENANT_ID;
    return TENANT_PRESETS[tenant] || TENANT_PRESETS[resolveTenantId()];
  }

  static get APP_NAME() {
    return Env.preset.appName;
  }

  static get APP_SHORT_NAME() {
    return Env.preset.appShortName;
  }

  static get APP_DESCRIPTION() {
    return Env.preset.appDescription;
  }

  static get LOGO_ALT() {
    return Env.preset.logoAlt;
  }

  static get ADMIN_PDF_NAME() {
    return Env.preset.adminPdfName;
  }

  static get RESELLER_PDF_NAME() {
    return Env.preset.resellerPdfName;
  }

  static get PUBLIC_URL() {
    return process.env.REACT_APP_PUBLIC_URL || process.env.PUBLIC_URL || '';
  }

  static get LOGO_URL() {
    return `${Env.PUBLIC_URL}/tenants/${Env.TENANT_ID}/logo.png`;
  }

  static get FAVICON_URL() {
    if (!Env.preset.faviconPath) {
      return '';
    }
    return `${Env.PUBLIC_URL}/${Env.preset.faviconPath}`;
  }

  static get API_BASE() {
    return process.env.REACT_APP_API_BASE || Env.preset.apiBase;
  }

  static NODE_ENV = process.env.NODE_ENV || 'development';

  // Downtime configuration (ISO 8601 format: YYYY-MM-DDTHH:mm:ss)
  static DOWNTIME_START = process.env.REACT_APP_DOWNTIME_START || '';
  static DOWNTIME_END = process.env.REACT_APP_DOWNTIME_END || '';
}

export default Env;
